import {
    displayCategory,
    displayCurrentRole,
    displayFormType,
    displayIpLocation,
    displayText,
    formatEnquiryDate,
    getResumePath,
    getResumeUrl,
    parseEnquiryMore,
    type EnquiryRow,
} from "./enquiry-helpers";

export const ENQUIRY_EXPORT_COLUMNS = [
    { label: "Date", key: "date" },
    { label: "Form Type", key: "formType" },
    { label: "Category", key: "category" },
    { label: "Name", key: "name" },
    { label: "Phone", key: "phoneno" },
    { label: "Email", key: "email" },
    { label: "Address", key: "location" },
    { label: "Current Role", key: "currentRole" },
    { label: "LinkedIn", key: "linkedin" },
    { label: "Experience", key: "experience" },
    { label: "Resume", key: "resume" },
    { label: "Message", key: "message" },
    { label: "IP Address", key: "ip" },
    { label: "IP Location", key: "ipLocation" },
    { label: "Browser", key: "browser" },
];

export const mapEnquiriesForExport = (rows: EnquiryRow[]) =>
    rows.map((row) => {
        const more = parseEnquiryMore(row);
        const resumePath = getResumePath(row);

        return {
            date: formatEnquiryDate(row.timestamp),
            formType: displayFormType(row),
            category: displayCategory(row),
            name: displayText(row.name),
            phoneno: displayText(row.phoneno),
            email: displayText(row.email),
            location: displayText(row.location),
            currentRole: displayCurrentRole(row),
            linkedin: displayText(more.linkedin),
            experience: displayText(more.experience),
            resume: resumePath ? getResumeUrl(resumePath) : "-",
            message: displayText(row.message),
            ip: displayText(row.ip),
            ipLocation: displayIpLocation(row.reversedip),
            browser: displayText(row.browser),
        };
    });
